import styled from "styled-components";

export const Container = styled.a`
  font-family: "Lato", sans-serif;
  font-size: 14px;
  line-height: 16.8px;
  color: ${({ theme }) => theme.colors.gray[800]};
`;
